<template>
  <document-search
    v-bind="$attrs"
    data-test="order-search"
    document="order"
    item-title="qtm_reference_number"
    :menu-props="localMenuProps"
    :style="style"
  >
    <template v-slot:item="{ item, props: itemProps }">
      <slot name="item" :item="item" :props="itemProps">
        <order-search-item v-bind="itemProps" :order="item.raw" />
      </slot>
    </template>
  </document-search>
</template>

<script setup lang="ts">
import DocumentSearch from '@/components/search/document-search.vue'
import OrderSearchItem from '@/components/search/order-search-item.vue'

export interface Props {
  maxWidth?: number | string
  menuProps?: any
}

const props = defineProps<Props>()

const localMenuProps = computed(() => ({
  dataTest: 'order-search-menu',
  maxWidth: props.maxWidth,
  ...props.menuProps
}))

const style = computed(() => (props.maxWidth ? `max-width: ${props.maxWidth}px` : undefined))
</script>
